/**
 * Confirm Archive Modal Component
 * Confirmation dialog for archiving events with reason input
 */

import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

export interface ConfirmArchiveData {
    eventType: string;
    eventId: string;
    hasRunningBatches?: boolean;
    linkedEquipmentNames?: string[]; // Names of equipment linked to this event (for multi-equipment events)
}

export interface ConfirmArchiveResult {
    confirmed: boolean;
    reason: string;
}

@Component({
    selector: 'app-confirm-archive-modal',
    templateUrl: './confirm-archive-modal.component.html',
    styleUrls: ['./confirm-archive-modal.component.scss'],
  standalone: false
})
export class ConfirmArchiveModalComponent {
    // Predefined reasons for quick selection
    reasonOptions: string[] = [
        'Duplicate entry',
        'Data entry error',
        'Test/training event',
        'Incorrect equipment selected',
        'Event logged by mistake',
        'Other'
    ];

    selectedReason: string = '';
    customReason: string = '';
    showCustomInput: boolean = false;

    constructor(
        public dialogRef: MatDialogRef<ConfirmArchiveModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ConfirmArchiveData
    ) { }

    selectReason(reason: string): void {
        this.selectedReason = reason;
        this.showCustomInput = reason === 'Other';
        if (reason !== 'Other') {
            this.customReason = '';
        }
    }

    getArchiveReason(): string {
        if (this.selectedReason === 'Other') {
            return this.customReason.trim() || 'Other';
        }
        return this.selectedReason;
    }

    isValid(): boolean {
        if (!this.selectedReason) return false;
        if (this.selectedReason === 'Other' && !this.customReason.trim()) return false;
        return true;
    }

    onCancel(): void {
        this.dialogRef.close({ confirmed: false, reason: '' });
    }

    onConfirm(): void {
        this.dialogRef.close({
            confirmed: true,
            reason: this.getArchiveReason()
        });
    }
}
